import React, { useEffect, useState } from "react"
import { Button, Col, FormGroup, Input, Label, Modal, Row } from "reactstrap"
import PropTypes from "prop-types"
import { NIL } from "uuid"
import Select from "react-select"
import { unitOfMeasurmentService } from "services/unit-of-measurement-service"
import NumberFormat from "react-number-format"
import { hasAccess } from "../../helpers/utils"
import { permission } from "../../constants/permission"
import LocationSelection from "../location/LocationSelection";
import WarehouseSelect from "../warehouse/WarehouseSelect";

const ModalForm = props => {
  const { isOpen, toggle, title, onSubmit } = props

  const [ item, setItem ] = useState({
    id: NIL,
    title: '',
    itemId: null,
    warehouseId: null,
    unitOfMeasurementId: null,
    locationId: null,
    displayOrder: 0,
    isBase: false,
    onHandQuantity: 0,
    outgoingQuantity: 0,
    minQuantity: 0,
    conversionRate: 1,
    note: '',
  })

  const [ submitted, setSubmitted ] = useState(false)
  const [ unitOfMeasurementOptions, setUnitOfMeasurementOptions ] = useState([])

  useEffect(() => {
    unitOfMeasurmentService.getAllRequest({ pageSize: 22 }).then(res => {
      const { data } = res

      setUnitOfMeasurementOptions(
          data.map(a => {
            return {
              id: a.id,
              value: a.id,
              label: a.name,
            }
          })
      )
    })
  }, [])

  const handleOnChange = (e) => {
    const { name, value } = e.target

    setItem({
      ...item,
      [name]: value
    })
  }

  const handleOnCheck = e => {
    const { name, checked } = e.target

    setItem({
      ...item,
      [name]: checked
    })
  }

  const handleSelectChange = (valueType, actionMeta) => {
    const { name } = actionMeta

    setItem({
      ...item,
      [name]: valueType
    })
  }

  const onOpened = () => {
    const { item } = props

    if (item) {
      setItem({
        ...item,
        unitOfMeasurementId: item.unitOfMeasurementId ? {
          id: item.unitOfMeasurementId,
          value: item.unitOfMeasurementId,
          label: item.unitOfMeasurementName,
        } : null,
        warehouseId: item.warehouseId ? {
          id: item.warehouseId,
          value: item.warehouseId,
          label: item.warehouseName,
        } : null,
        locationId: item.locationId ? {
          key: item.locationId,
          value: item.locationId,
          label: item.locationName,
        }: null,
        note: item?.note || ''
      })
    } else {
      setItem({
        id: NIL,
        title: '',
        itemId: null,
        warehouseId: null,
        unitOfMeasurementId: null,
        locationId: null,
        displayOrder: 0,
        isBase: false,
        onHandQuantity: 0,
        outgoingQuantity: 0,
        minQuantity: 0,
        conversionRate: 1,
        note: '',
      })

      setSubmitted(false)
    }
  }

  const handleSubmit = () => {
    setSubmitted(true)
    let isValid = item.title 
        && item.warehouseId 
        && item.unitOfMeasurementId 
        && item.locationId && item.conversionRate > 0

    if (isValid) {
      const data = {
        ...item,
        warehouseId: item.warehouseId?.value,
        unitOfMeasurementId: item.unitOfMeasurementId?.value,
        locationId: item.locationId?.value,
      }

      onSubmit(data)
    }
  }

  return (
      <Modal
          size="md"
          onOpened={ onOpened }
          isOpen={ isOpen }
          toggle={ toggle }
          backdrop="static"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            { title }
          </h5>
          <button
              type="button"
              onClick={ toggle }
              className="close"
              data-dismiss="modal"
              aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="modal-body">
          <Row>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="">Title</Label>
                <Input
                    type="text"
                    name="title"
                    placeholder="Title"
                    className={ submitted && !item.title ? "is-invalid" : "" }
                    value={ item.title }
                    onChange={ handleOnChange }
                />
                { submitted && !item.title && (
                    <div className="invalid-feedback-custom">Title is required.</div>
                ) }
              </FormGroup>
              <div className="mb-3">
                <div
                    className={
                        "select2-container" +
                        (submitted && !item.warehouseId ? " is-invalid" : "")
                    }
                >

                  <Label htmlFor="">Warehouse</Label>
                  <WarehouseSelect value={ item.warehouseId } onChange={ option => {
                    setItem({
                      ...item,
                      warehouseId: option
                    })
                  } }/>
                </div>
                { submitted && !item.warehouseId && (
                    <div className="invalid-feedback-custom">
                      Warehouse is required.
                    </div>
                ) }
              </div>

            </Col>
          </Row>
          { hasAccess(permission.adjustStock.enable) && (
              <Row>
                <Col>
                  <FormGroup className="mb-3">
                    <Label htmlFor="">On Hand</Label>
                    <NumberFormat
                        name="onHandQuantity"
                        value={ item.onHandQuantity }
                        className={ "form-control text-end" }
                        thousandSeparator={ true }
                        fixedDecimalScale={ false }
                        onValueChange={ values => {
                          values.floatValue = parseFloat(values.value)
                          setItem({
                            ...item,
                            onHandQuantity: values.floatValue
                          })
                        } }
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup className="mb-3">
                    <Label htmlFor="">Outgoing</Label>
                    <NumberFormat
                        name="outgoingQuantity"
                        value={ item.outgoingQuantity }
                        className={ "form-control text-end" }
                        thousandSeparator={ true }
                        fixedDecimalScale={ false }
                        onValueChange={ values => {
                          values.floatValue = parseFloat(values.value)
                          setItem({
                            ...item,
                            outgoingQuantity: values.floatValue
                          })
                        } }
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup className="mb-3">
                    <Label htmlFor="">Min</Label>
                    <NumberFormat
                        name="minQuantity"
                        value={ item.minQuantity }
                        className={ "form-control text-end" }
                        thousandSeparator={ true }
                        fixedDecimalScale={ false }
                        onValueChange={ values => {
                          values.floatValue = parseFloat(values.value)
                          setItem({
                            ...item,
                            minQuantity: values.floatValue
                          })
                        } }
                    />
                  </FormGroup>
                </Col>
              </Row>
          ) }
          <Row>
            <Col>
              <div className="mb-3">
                <div
                    className={
                        "select2-container" +
                        (submitted && !item.unitOfMeasurementId ? " is-invalid" : "")
                    }
                >
                  <Label>Unit of Measurement</Label>
                  <Select
                      name="unitOfMeasurementId"
                      value={ item.unitOfMeasurementId }
                      onChange={ handleSelectChange }
                      options={ unitOfMeasurementOptions }
                      classNamePrefix="select2-selection"
                      isClearable
                  />
                </div>
                { submitted && !item.unitOfMeasurementId && (
                    <div className="invalid-feedback-custom">
                      Unit of Measurement is required.
                    </div>
                ) }
              </div>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="">Conversion Rate</Label>
                <NumberFormat
                    name="conversionRate"
                    value={ item.conversionRate }
                    className={
                        "form-control text-end " +
                        (submitted && item.conversionRate === 0 ? "is-invalid" : "")
                    }
                    thousandSeparator={ true }
                    fixedDecimalScale={ false }
                    onValueChange={ values => {
                      values.floatValue = parseFloat(values.value)
                      setItem({
                        ...item,
                        conversionRate: values.floatValue
                      })
                    } }
                />

                { submitted && !item.conversionRate && (
                    <div className="invalid-feedback-custom">ConversionRate is required.</div>
                ) }
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="mb-3">
                <div
                    className={
                        "select2-container" +
                        (submitted && !item.locationId ? " is-invalid" : "")
                    }
                >
                  <Label>Location</Label>
                  <LocationSelection name={ "locationId" } value={ item.locationId } onChange={ handleSelectChange }/>
                </div>
                { submitted && !item.locationId && (
                    <div className="invalid-feedback-custom">
                      Location is required.
                    </div>
                ) }
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="">Display Order</Label>
                <Input
                    type="number"
                    name="displayOrder"
                    placeholder="Display Order"
                    value={ item.displayOrder }
                    onChange={ handleOnChange }
                />
              </FormGroup>
            </Col>
            <Col>

            </Col>
          </Row>
          <Row>
            <Col>
              <div className="form-check form-check-primary mb-3">
                <input
                    type="checkbox"
                    className="form-check-input"
                    id="customCheckcolor1"
                    name="isBase"
                    checked={ item.isBase }
                    onChange={ handleOnCheck }
                />
                <label
                    className="form-check-label"
                    htmlFor="customCheckcolor1"
                >
                  Is Based
                </label>
              </div>
              <FormGroup className="mb-3">
                <Label htmlFor="">Note</Label>
                <Input
                    type="textarea"
                    name="note"
                    placeholder="Note"
                    value={ item.note }
                    onChange={ handleOnChange }
                />
              </FormGroup>
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <Button color="primary" onClick={ handleSubmit } type="submit">
            Submit
          </Button>
          <button
              type="button"
              onClick={ toggle }
              className="btn btn-secondary"
              data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </Modal>
  )
}

ModalForm.propTypes = {
  item: PropTypes.object,
  title: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func,
  onSubmit: PropTypes.func,
}

export default ModalForm
